import PropTypes from 'prop-types'

import {
  Box,
  Columns,
  Col,
  Icon,
  Heading,
  Image,
  Label,
  Link,
  Text,
} from '@redriverpress/system'

import getInitialState from 'Common/utils/getInitialState'

import ImagePlaceholder from './ImagePlaceholder'
import HitWrapper from './HitWrapper'
import LevelsAndAudiences from './LevelsAndAudiences'
import { flashcard, flashcardCategory } from '../../constants/materialTypes'
import {
  flashcardPropShape,
  flashcardCategoryPropShape,
} from '../../constants/propShapes'
import { getFlashcardLink } from '../../utils/hitLinks'
import { resultImageSize } from '../../constants/ui'
import getHitLevelsByType from '../../utils/getHitLevelsByType'
import getPreferredLevelType from '../../utils/getPreferredLevelType'

export default function GenericFlashcardHit({ hit }) {
  const {
    audiences,
    category, // flashcards only
    genre, // flashcards & flashcard categories
    image_url: imageUrl,
    id, // flashcards & flashcard categories
    levels,
    slug, // flashcard categories
    title,
    type,
  } = hit

  const { levelPreference } = getInitialState()

  const hitLevels = getHitLevelsByType(levelPreference, hit)

  // If the user's level preference isn't Ellii's,
  // but there are no levels on this hit for their level type,
  // use Ellii's levels.
  // Otherwise, use their level preference.
  const preferredLevelType = getPreferredLevelType(levelPreference, hitLevels)

  const link =
    type === flashcard
      ? getFlashcardLink({
          genreSlug: genre.slug,
          categorySlug: category.slug,
          id,
        })
      : getFlashcardLink({ genreSlug: genre.slug, categorySlug: slug })

  return (
    <Link reset href={link}>
      <HitWrapper px={3} py={[3, null, 4]} mb={[3, null, 4]}>
        <Columns>
          <Col width={[1, null, 1 / 4]}>
            <Box mb={[3, null, 0]}>
              {imageUrl ? (
                <Image
                  alt=''
                  src={imageUrl}
                  size={resultImageSize}
                  display='block'
                  mx={[undefined, null, 'auto']}
                  borderRadius={
                    type === flashcardCategory ? 'circular' : 'rounded'
                  }
                />
              ) : (
                <ImagePlaceholder />
              )}
            </Box>
          </Col>
          <Col width={[1, null, 3 / 4]}>
            <Box mb={3}>
              <Label compact type='materialType'>
                <Icon
                  icon={type === flashcardCategory ? 'images' : 'bolt'}
                  pr={2}
                />
                {type === flashcardCategory
                  ? 'Flashcard Category'
                  : 'Flashcard'}
              </Label>
            </Box>
            <Heading as='h4' mb={1}>
              {title}
            </Heading>
            <Text fontWeight={600}>{category && category.title}</Text>
            <Box my={3}>
              <LevelsAndAudiences
                audiences={audiences}
                eslLevels={levels}
                preferredLevels={hitLevels}
                preferredLevelType={preferredLevelType}
              />
            </Box>
          </Col>
        </Columns>
      </HitWrapper>
    </Link>
  )
}

GenericFlashcardHit.propTypes = {
  hit: PropTypes.oneOfType([flashcardPropShape, flashcardCategoryPropShape])
    .isRequired,
}
